module.exports = "https://web-assets.ifttt.com/packs/media/products/device-android-ed3a31e2.png";